import _ from 'lodash';

import BaseStore from './BaseStore';
import UserStore from './UserStore';
import { ActionTypes } from '../constants/AppConstants';

class TokenStore extends BaseStore {

    getDevice () {
        return this.state.get('device');
    }

    getCustomer () {
        return UserStore.getCurrent().accessToken;
    }

    getActionHandlers () {
        return {
            [ ActionTypes.DEVICE_TOKEN_UPDATED ]: this.handleNewToken,
            [ ActionTypes.LOGGED_OUT ]: this.resetState,
        };
    }

    handleNewToken ({ token }) {
        if (_.isUndefined(token)) { token = null; }
        this.setState(this.state.set('device', token));
    }

}


const instance = new TokenStore({ storageKey: 'tokens' });

export default instance;
